interface BatchCollectionSourceAccount {
  serviceProvider: string;
  attributes?: Record<string, unknown>;
}

export const isBatchCollectionSourceAccount = ({ serviceProvider }: BatchCollectionSourceAccount) =>
  serviceProvider === 'inventi';

export const isBatchCollectionAllowedAccount = (account: BatchCollectionSourceAccount) =>
  isBatchCollectionSourceAccount(account) &&
  (account.attributes?.sddCollectionAllowed === true ||
    account.attributes?.sddCollectionAllowed === 'true');
